import { useState, useEffect } from 'react';
import { settingsService } from '../services/settingsService';

/**
 * Hook som leser innstillingen 'picking.autoCreateAndPrintKolliOnPickStart'.
 *
 * Styrer om en kolli auto-opprettes og kolli-etiketten skrives ut automatisk
 * når operatøren åpner et plukk (PLOCK-2 KRAV 1, portert fra regionsløsningen).
 * Ved gjenopptak av plukk (eksisterende åpen kolli) skjer ingenting.
 *
 * Oppløsning følger hierarkiet Profile → System → Default via getEffectiveSetting.
 *
 * Default: false (av med mindre tenant/profil eksplisitt slår den på).
 */
export function useAutoCreateAndPrintKolliOnPickStart(): boolean {
  const [enabled, setEnabled] = useState<boolean>(false);

  useEffect(() => {
    let cancelled = false;

    const loadSetting = async () => {
      try {
        const setting = await settingsService.getEffectiveSetting('picking.autoCreateAndPrintKolliOnPickStart');
        if (!cancelled) {
          if (setting && setting.currentValue !== null && setting.currentValue !== undefined) {
            const val = setting.currentValue.toString().toLowerCase();
            setEnabled(val === 'true' || val === '1' || val === 'ja');
          } else {
            // Ingen verdi satt → bruk default (av)
            setEnabled(false);
          }
        }
      } catch (err) {
        console.warn('Could not load picking.autoCreateAndPrintKolliOnPickStart setting, defaulting to false:', err);
        if (!cancelled) {
          setEnabled(false);
        }
      }
    };

    loadSetting();

    return () => { cancelled = true; };
  }, []);

  return enabled;
}
